// extracted by mini-css-extract-plugin
export default {"suggestions-div":"_suggestions-div_5GAT0F"};